import ConnectionsActions from '../actions/MailchimpConnectionsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, update } from './common/commonReducers';
import { mailchimpConnections } from '../interfaces/connections';
import { Pagination } from '../store-interfaces';
import ConnectionModel from '../model/ConnectionModel';

const initialState: mailchimpConnections = {
  busy: false,
  entities: [],
  widgetConnections: null,
  pagination: {} as Pagination,
};

export default function forms(
  state: mailchimpConnections = initialState,
  action,
): mailchimpConnections {
  switch (action.type) {
    case ConnectionsActions.busyAction:
      return setBusy(state);
    case ConnectionsActions.unbusyAction:
      return setUnBusy(state);
    case ConnectionsActions.updateAction:
      return update(state, action);
    case ConnectionsActions.retrievedAction: {
      const { entity: newConnection } = action;
      const connectionIndex = state.entities.findIndex(
        connection =>
          connection.id === newConnection.id &&
          connection.connectionType === newConnection.connectionType,
      );
      let entities: ConnectionModel[];

      if (connectionIndex !== -1) {
        entities = [
          ...state.entities.slice(0, connectionIndex),
          newConnection,
          ...state.entities.slice(connectionIndex + 1),
        ];
      } else {
        entities = [...state.entities, newConnection];
      }

      return {
        ...state,
        busy: false,
        entities,
      };
    }

    case ConnectionsActions.deleteLocalAction: {
      const { connectionType, id: connectionId } =
        action.entity as ConnectionModel;
      const entities = state.entities.filter(
        c => c.id !== connectionId || c.connectionType !== connectionType,
      );
      return {
        ...state,
        busy: false,
        entities,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    case ConnectionsActions.retrievedAllAction: {
      const { connections, pagination } = action.entities;
      return {
        ...state,
        busy: false,
        entities: connections,
        pagination,
      };
    }

    case ConnectionsActions.retrieveWidgetConnectionsAction: {
      const { connections } = action;

      return {
        ...state,
        busy: false,
        widgetConnections: connections,
      };
    }

    case ConnectionsActions.updateVariableOptionsAction: {
      const { options } = action;

      return {
        ...state,
      };
    }

    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
